import {StandardSetModelV1} from '../../GeneratedModels/StandardSet/StandardSetModel.v1';

import {standardSetModelValidators} from './StandardSetModel.v1.validators';

StandardSetModelV1.addValidators(standardSetModelValidators);

export {StandardSetModelV1};
